import { render, staticRenderFns } from "./UsuariosOnLine.vue?vue&type=template&id=bd2aab92&"
import script from "./UsuariosOnLine.vue?vue&type=script&lang=js&"
export * from "./UsuariosOnLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports